// src/components/PanelFiltros.js
import React from 'react';
import '../style/components/PanelFiltros.css';

/**
 * Un campo del panel de filtros: etiqueta gris con ícono y el control (input/select) debajo.
 * El control lleva la clase `panel-filtros-input` además de `form-control`/`form-select`.
 * `ancho` lo deja crecer (para buscadores de texto); `opcional` agrega "(opcional)".
 */
export const CampoFiltro = ({ etiqueta, icono, htmlFor, opcional = false, ancho = false, children }) => (
    <div className={ancho ? 'panel-filtros-campo-ancho' : 'panel-filtros-campo'}>
        <label className="panel-filtros-label" htmlFor={htmlFor}>
            {icono && <i className={`bi ${icono} me-2`} aria-hidden="true"></i>}
            {etiqueta}
            {opcional && <span className="panel-filtros-opcional"> (opcional)</span>}
        </label>
        {children}
    </div>
);

/**
 * Caja gris de filtros, con la estética de Histórico de Turnos (ver .filtrosAgenda en
 * Turnero.module.css): se despega del fondo blanco de la página, los campos van en una fila
 * que se acomoda sola y "Limpiar" aparece solo cuando hay algún filtro aplicado.
 * `resumen` (p. ej. "Mostrando 3 de 19 motivos") va debajo, en texto chico.
 */
const PanelFiltros = ({ children, hayFiltros = false, onLimpiar, resumen }) => (
    <div className="panel-filtros">
        <div className="panel-filtros-fila">
            {children}
            {hayFiltros && onLimpiar && (
                <button type="button" className="rec-btn-secondary panel-filtros-limpiar" onClick={onLimpiar}>
                    Limpiar
                </button>
            )}
        </div>
        {resumen && <div className="panel-filtros-resumen">{resumen}</div>}
    </div>
);

export default PanelFiltros;
